import type { ReactNode } from 'react';

export const symbol_not_listed_location: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.5-103.5Q448-107 440-115q-42-38-91-87.5T258-309q-42-57-70-119t-28-124q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 62-28 124t-70 119q-42 57-91 106.5T520-115q-8 8-18.5 11.5T480-100q-11 0-21.5-3.5ZM506-336q11-11 11-26t-11-26q-11-11-26-11t-26 11q-11 11-11 26t11 26q11 11 26 11t26-11Zm-25-113q10 0 17-7t7-18q0-8 4-17t11-17q5-5 11.5-11t13.5-12q24-22 34-41.5t10-45.5q0-42-31.5-69.5T483-715q-32 0-60 15.5T379-655q-5 9-2 18.5t12 14.5q9 5 18.5 1.5T422-632q9-17 25.5-26t35.5-9q23 0 39.5 14.5T539-616q0 17-8 30t-28 31q-10 8-17.5 16T473-524q-8 11-12 22t-4 22q0 12 6.5 21.5T481-449Zm-1 290q133-121 196.5-219.5T740-552q0-118-75.5-193T480-820q-109 0-184.5 75T220-552q0 75 65 173.5T480-159Zm0-401Z"
		/>
	</svg>
);
